/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import { type Frame, type Request } from '../../interface/Crash';
import { RequestJsiView } from './RequestJsiView';
import { ResponseBodyView } from './ResponseBodyView';
import { RequestTypeTag } from '../RequestTags';
import { CallstackView } from './CallstackView';

export const JsiDetail: React.FC<{
    request: Request;
    reportKind: 'crash' | 'protocol';
    callstack?: Frame[];
    reportId: string;
    requestId: number;
}> = ({ request, callstack, reportKind, reportId, requestId }) => {
    const defaultIndex = callstack ? 2 : 0;

    return (
        <>
            <Box paddingBottom={10}>
                <Box as="span">
                    <RequestTypeTag value="JSI" />
                </Box>
                <Text paddingStart={2} as="span" flex="1" fontWeight="semibold">
                    {request.url}
                </Text>
            </Box>
            <Tabs defaultIndex={defaultIndex}>
                <TabList>
                    <Tab>JSI Frames</Tab>
                    <Tab>Final DOM</Tab>
                    {callstack && <Tab>Callstack</Tab>}
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <RequestJsiView request={request} />
                    </TabPanel>
                    <TabPanel>
                        <ResponseBodyView
                            request={request}
                            reportKind={reportKind}
                            reportId={reportId}
                            requestId={requestId}
                        />
                    </TabPanel>
                    {callstack && (
                        <TabPanel>
                            <CallstackView callstack={callstack} />
                        </TabPanel>
                    )}
                </TabPanels>
            </Tabs>
        </>
    );
};
